
require('./bootstrap');

import { DateTime } from 'luxon';
import {TabulatorFull as Tabulator} from 'tabulator-tables';

window.DateTime = DateTime;
window.Tabulator = Tabulator;

window.SGData = {
    // crea un grafico con coppia key:value
    createChart(canvasId, data) {
        // Get the canvas element by its ID
        var canvas = document.getElementById(canvasId);

        // se esiste giù un grafico sullo stesso canavsID, lo distrugge
        if (canvas.chart) {
            canvas.chart.destroy();
        }

        // Crea una nuova istanza con i parametri settati
        canvas.chart = new Chart(canvas, {
            type: 'line',
            data: data,
            options: {
                responsive: true,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
        return canvas.chart;
    },

    bytesToHuman(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },

    //formatta la data per un elemento datatable
    renderDT: { 
        renderDatetime: function(data, type, row, meta){
            let date = new Date(data);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        },
        renderDate: function(data, type, row, meta){
            let date = new Date(data);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        },
        tipoDataOra: function (d, type, row) {
            if(d != null){
                let data = new Date(d);
                switch (type) {
                    case "display":
                    case "filter":
                        return data.toLocaleDateString() + ' ' + data.toLocaleTimeString();
                        break;
                    case "export":
                        return data.toLocaleDateString()
                    case "sort":
                        return data.getFullYear()+'.'+data.getMonth()+'.'+data.getDate()+' '+data.getHours()+':'+data.getMinutes()
                        break;
                    case "type":
                        return data.toLocaleDateString()
                        break;
                    default:
                        console.log({ type, data });
                        break;
                }
            }
            return "-";
        }
    }, 

    //visualizza notifica alert a scomparsa
    showAlert: function (type, message, $recipient, timeout = 3500) { 
        let icon = type == 'success' ? '<i class="fa fa-check"></i> ' : '<i class="fa fa-exclamation"></i> '
        let template = `<div id="alert-window" class="alert alert-${type} alert-dismissible" role="alert">
                            ${icon} ${message}
                        </div>`;
        if(typeof value !== "undefined" && $recipient.length)
            $recipient.html(template)
        else
            $('#alert-message').html(template)
        
        $('#alert-window').addClass("fade show")
        setTimeout(function() {
            $('#alert-window').alert("close")
        }, timeout);        
    },

    /**
     * Permette di copiare (CTRL+c) in automatico il testo cliccandoci
     */
    textToClipboard: function (text) {
        navigator.clipboard.writeText( text )
        this.showAlert('success', 'Il testo è stato copiato negli appunti')
    },

    /**
     * Permette la preview di un file pdf con la libreria pdf.js
     * 
     * @param {*} file 
     * @param {*} recipient 
     */
    pdfPreview: function (file, recipient = 'anteprima-pdf') {
        let pdfDoc = null,
            pageNum = 1,
            pageRendering = false,
            pageNumPending = null,
            scale = 1.4,
            canvas = document.getElementById(recipient),
            ctx = canvas.getContext('2d');
    
        // Loaded via <script> tag, create shortcut to access PDF.js exports.
        let pdfjsLib = window['pdfjs-dist/build/pdf'];
    
        // The workerSrc property shall be specified.
        pdfjsLib.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.3.122/pdf.worker.min.js';
    
        canvas.style.border = '1px solid black';
        /**
         * Get page info from document, resize canvas accordingly, and render page.
         * @param num Page number.
         */
        function renderPage(num) {
            pageRendering = true;
            // Using promise to fetch the page
            pdfDoc.getPage(num).then(function(page) {
                var viewport = page.getViewport({ scale: scale });
                canvas.height = viewport.height;
                canvas.width = viewport.width;
    
                // Render PDF page into canvas context
                var renderContext = {
                    canvasContext: ctx,
                    viewport: viewport
                };
                var renderTask = page.render(renderContext);
    
                // Wait for rendering to finish
                renderTask.promise.then(function() {
                    pageRendering = false;
                    if (pageNumPending !== null) {
                        // New page rendering is pending
                        renderPage(pageNumPending);
                        pageNumPending = null;
                    }
                });
            });
            // Update page counters
            document.getElementById('page_num').textContent = num;
        }
    
        /**
         * If another page rendering in progress, waits until the rendering is
         * finised. Otherwise, executes rendering immediately.
         */
        function queueRenderPage(num) {
            if (pageRendering) {
                pageNumPending = num;
            } else {
                renderPage(num);
            }
        }
    
        /**
         * Asynchronously downloads PDF.
         */
        pdfjsLib.getDocument(file).promise.then(function(pdfDoc_) {
            pdfDoc = pdfDoc_;
            document.getElementById('page_count').textContent = pdfDoc.numPages;
    
            // Initial/first page rendering
            renderPage(pageNum);
        });
    }
}